export default __webpack_public_path__ + "25d0be1b1290f3c3d024b8bd9089fd16.svg";